/* eslint-disable */

<template>
    <v-expansion-panel accordion v-if="c_location">
        <v-expansion-panel-header color="expansion" hide-actions class="px-3 py-2">
            <v-container class="ma-0 px-0 pt-1 pb-0 fill-height fluid">
                <v-row no-gutters>
                    <v-col cols="12" sm="12" md="2" class="d-flex align-start justify-end order-xs-1 order-sm-1 order-md-2">
                    <v-btn
                        fab
                        small
                        class="ma-1"
                        v-can="{obj_type:'location', action: 'edit'}"
                    ><v-icon @click.stop="$emit('edit_location', c_location._id)">edit</v-icon></v-btn>
                    <v-btn
                        fab
                        small
                        class="ma-1"
                        v-can="{obj_type:'location', action: 'remove'}"
                    ><v-icon @click.stop="deleteLocation">delete</v-icon></v-btn>
                    </v-col>
                <v-col cols="12" sm="12" md="10" class="d-flex align-start order-xs-2 order-sm-2 order-md-1 pb-1">
                        <span>
                            <v-icon>expand_more</v-icon>
                        </span>
                        <span>
                        <b>{{ c_location.name }}</b> - 
                        <i>{{c_location.address}} {{c_location.addrNum}} - {{c_location.zip}}, {{c_location.city}} ({{ c_location.district }}), {{c_location.country}}</i><br/>
                        <i><span v-if="c_location.contacts.length > 0">Contatti: <span v-for="(_cid, dc_idx) of c_location.contacts" :key="dc_idx"><b>{{ address_book[_cid] }}</b><span v-if="dc_idx < (c_location.contacts.length-1)">, </span></span></span></i>
                        </span>
                </v-col>
                </v-row>
            </v-container>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="ma-0 pr-0">
            <v-card class="ma-0 elevation-0 pa-0">
                <v-card-title class="d-flex pa-0">
                <div class="d-flex ml-2 align-center justify-start flex-grow-1 flex-shrink-0 subtitle-2 font-italic">
                    <span v-if="departments.length>0">Reparti</span><span v-else>Nessun reparto</span>
                </div>
                <div class="d-flex align-center justify-start flex-grow-0 flex-shrink-1">
                    <v-btn pa-0 ma-0 text @click.stop="addDepartment(location)"><v-icon small class="mr-1">add_box</v-icon>reparto</v-btn>
                </div>
                </v-card-title>
                <v-card-text class="pa-0">
                <div class="d-flex flex-column" v-for="(dep, d_idx) in departments" :key="d_idx+'_'+dep.id">
                    <LocationDepartment 
                        v-on:department_update="updateDepartment"
                        v-on:department_remove="removeDepartment"
                        v-bind:o_department="dep"
                        v-bind:o_idx="d_idx"
                        :loc_id="loc_id"
                        v-bind:new=isDepartmentNew(dep.id)
                        v-bind:address_book="address_book"
                        v-bind:contacts="contacts">
                    </LocationDepartment>
                </div>
                </v-card-text>
            </v-card>
            <div>&nbsp;
            <AuthorInfo
                :key="c_location.updated"
                :created="c_location.created"
                :created_by="c_location.created_by"
                :updated="c_location.updated"
                :updated_by="c_location.updated_by"/>
            </div>
    </v-expansion-panel-content>
    </v-expansion-panel>
</template>
<script>
// import _ from 'lodash'
import LocationDepartment from "./LocationDepartment"
import AuthorInfo from '../../components/utils/AuthorInfo'
import {getModel} from '../../utils/model'
import { searchDesign } from "../../utils/dbUtility"

export default {
    components: {LocationDepartment, AuthorInfo},
    props: [
        "loc_id", "contacts", "l_idx", "location"
    ],
    data(){
        return {
            c_location: null,
            nameRules: [
                v => !!v || 'Campo obbligatorio',
                v => /^.{3,}$/.test(v) || 'Minimo 3 caratteri'
            ],
            departments: {},
            address_book: {},
            edit: false,
            expanded: false,
            deletable: false
        }
    },
    async mounted() {
        this.c_location = await this.$store.state.$pouch.get('registry', this.loc_id)
        this.departments = Object.values(this.c_location.departments)
        this.address_book = {}
        this.getABMap()
        await this.isDeletable()
    },
    watch: {
        'contacts': {
            deep: true,
            handler() {
                this.getABMap()
            }
               
        }
    },
    methods: {
        getABMap() {
            if (this.c_location) {
                for (let contact of this.contacts) {
                    this.$set(this.address_book, contact.id, contact.name)
                }
                this.c_location.contacts = this.c_location.contacts.filter(this.c_exists);
            }
        },
        c_exists(v){ 
            // console.log(v, Object.keys(this.address_book).indexOf(v))
            return Object.keys(this.address_book).indexOf(v)>=0
        },
        addDepartment(idx) {
            let Department = getModel("Department");
            if (!this.departments) {
                this.departments = []
            }
            this.departments.push(Department({id: new Date().getTime().toString()}))
            console.log("DEPARTMENTS:",this.departments)
        },
        async updateDepartment(department, idx) {
            // console.log("save department",department, idx)
            try{
                if (department.id == this.departments[idx].id) {
                    await this.saveLocation()
                    this.$set(this.departments, idx, department)
                    // console.log("update department",this.departments)
                    this.c_location.departments[department.id] = department
                    
                }
            } catch(error) {
                console.log('error', error)
                if (this.isDepartmentNew(department.id)) {
                    let item = this.departments.splice(idx, 1);
                    // console.log('****', idx, item)
                    delete this.c_location.departments[department.id]
                }
            }
        },
        async isDepartmentDeletable(id) {
            let res = await searchDesign(this.$store.state.$pouch, 'registry', 'instruments/searchByData', 'key', [this.loc_id, id], true)
            if (res.length > 0) {
                return res[0].value > 0 ? false : true
            } else {
                return true
            }
            
            
        },
        async removeDepartment(id, idx) {
            // console.log('remove dep', idx, id)
            let d_id = this.departments[idx].id
            let isDeletable = await this.isDepartmentDeletable(id)
            if (id == d_id && isDeletable) {
                await this.saveLocation()
                let item = this.departments.splice(idx, 1);
                // console.log('****', idx, item)
                delete this.c_location.departments[id]
            } else {
                this.$store.commit("showSnackbar", {text: "Reparto non cancellabile, sono presenti degli strumenti", color: 'error'})
            }
        },
        async saveLocation() {
            this.c_location.updated_by = this.$store.state.user._id
            this.c_location.updated = (new Date()).getTime()
            let res = await this.$store.state.$pouch.put('registry', this.c_location)
            if (res.ok) {
                this.c_location._rev = res.rev
                //console.log("Update location " , res)
                this.$emit("update_location", this.c_location, this.l_idx)
                return true
            }
            return false
        },
        isDepartmentNew(id) {
            let dep = this.c_location.departments[id]
            // console.log('is dep new', dep)
            return (dep==undefined || dep==null)
        },
        async isDeletable() {
            let res = await searchDesign(this.$store.state.$pouch, 'registry', 'instruments/searchByData', 'key', ['location', this.loc_id], true)
            if (res.length > 0) {
                this.deletable = res[0].value > 0 ? false : true
            } else {
                this.deletable = true
            }
            
            
        },
        async deleteLocation() {
            await this.isDeletable()
            if (this.deletable) {
                this.$emit('remove_location', this.l_idx, this.c_location._id)
            } else {
                this.$store.commit("showSnackbar", {text: "Sede non cancellabile, sono presenti degli strumenti", color: 'error'})
            }
        }
    }
}

</script>